import React from 'react'
import { createRoot } from 'react-dom/client'
import Navigation from '../containers/Navigation';

document.addEventListener('turbo:load', () => {
  const container = document.getElementsByClassName('burgerMenu')[0]
  if (container) {
    createRoot(container).render(<Navigation />)
  }
})
